// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../hooks/useMergeProps';

import MatchCardOutright from './MatchCardOutright';
import selectMatchCardOutrightProps from './MatchCardOutright.selector';

type MatchCardOutrightContainerPropsType = {
  className?: string;
  matchId: number;
  image: string | null;
  startDate: number;
  tvChannel?: string;
  isFavorite: boolean;
  isLive?: boolean;
  showFavorite: boolean;
  betId: number;
  title: string;
  sportId: number;
  onFavoriteButtonClicked: () => void | null;
  to: string;
  categoryId: number;
  flagId?: string;
  betCategoryId?: number;
  expandId: string;
};

const MatchCardOutrightContainer = (ownProps: MatchCardOutrightContainerPropsType) => {
  const { matchId } = ownProps;

  const selectorProps = useMemo(() => ({ matchId }), [matchId]);
  const selectedProps = useSelector((state) => selectMatchCardOutrightProps(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <MatchCardOutright {...enhancedProps} />;
};

export default MatchCardOutrightContainer;
